// extracted by mini-css-extract-plugin
export default {"title":"CarouselPhotos_title__yzh6M","carousel":"CarouselPhotos_carousel__E6mvD","slide":"CarouselPhotos_slide__gh18K","image":"CarouselPhotos_image__s47aa"};